<template>
    <div>
        <transition name="modal">
            <div class="modal-mask" v-show="show">

                <div class="modal-wrapper">
                    <div class="close" @click="close"><i class="el-icon-switch-button"></i></div>
                    <div class="modal-container">

                        <h2>登录</h2>
                        <el-form :model="LoginForm" status-icon :rules="rules" ref="LoginForm"
                        >
                            <el-form-item prop="username">
                                <el-input prefix-icon="fa fa-user fa-lg" placeholder="用户名" v-model="LoginForm.username"
                                          autocomplete="on"></el-input>
                            </el-form-item>
                            <el-form-item prop="password">
                                <el-input prefix-icon="fa fa-unlock-alt fa-lg" placeholder="密码"
                                          type="password" v-model="LoginForm.password" autocomplete="on"></el-input>
                            </el-form-item>


                        </el-form>
                        <el-button class="btn-login" :loading="loading" @click="login">登录</el-button>
                    </div>

                </div>
            </div>
        </transition>
    </div>
</template>

<script>

    export default {
        name: "LoginPage",
        props: {
            show: {
                type: Boolean,
                default: false
            },
            loading: {
                type: Boolean,
                default: false
            }

        },
        data() {
            return {
                LoginForm: {
                    username: "",
                    password: "",
                },

                rules: {
                    username: [
                        {required: true, message: '请填写用户名', trigger: ['blur']},
                        // {min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur'}
                    ],
                    password: [
                        {required: true, message: '请输入密码', trigger: ['blur']},
                        // {min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur'}
                    ],
                },
            };
        },
        mounted() {
            const info=JSON.parse(localStorage.getItem('key'))
            if (info.username || info.password){
                this.LoginForm=info
            }
        },
        methods: {
            login() {
                // 模拟登录请求
                this.$refs['LoginForm'].validate((valid) => {
                    if (valid) {


                        this.$emit("confirm", this.LoginForm);


                        // this.hide();

                    } else {
                        this.$message({
                            message: "数据有误",
                            type: "error"

                        })

                    }
                })

            },

            close() {
                this.$emit("close");
                this.hide();

            },
            hide() {
                // this.show=false
                this.LoginForm.username = "";
                this.LoginForm.password = "";
            },
        },
    };
</script>

<style scoped>
    .modal-mask {
        position: fixed;
        z-index: 999;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(0, 0, 0, 0.5);
    }


    .modal-wrapper {
        background-color: #fff;
        border-radius: 10px;
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
        overflow: hidden;
        width: 450px;
        padding: 40px;
        position: relative;
    }

    .close {
        position: relative;
        top: -28px;
        float: right;
        /*color: #37A047;*/

    }

    .close:hover {
        color: #CAB899;
    }

    .close i {
        font-size: 22px;
        font-weight: bold;
    }

    .modal-container {
        display: flex;
        flex-direction: column;

    }

    h2 {
        text-align: center;
        margin-bottom: 20px;
        font-size: 28px;
    }

    .form-group {
        margin-bottom: 20px;
    }

    input {
        border-radius: 5px;
        border: 1px solid #ccc;
        padding: 12px;
        width: 100%;
    }

    .btn-login {
        background-color: #1C202B;
        border-radius: 5px;
        border: none;
        color: #CAB899;
        cursor: pointer;
        font-size: 22px;
        font-weight: bold;
        /*padding: 12px 0;*/
        transition: all 0.2s ease-in-out;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
    }

    .btn-login:hover {
        background-color: #2C202B;
    }

    /*.btn-login i {*/
    /*    position: absolute;*/
    /*    right: 50%;*/
    /*    top: 50%;*/
    /*    transform: translate(50%, -50%);*/
    /*    color: #fff;*/
    /*    font-size: 20px;*/
    /*}*/

    .modal-enter-active,
    .modal-leave-active {
        transition: all 0.3s;
    }

    .modal-enter,
    .modal-leave-to {
        opacity: 0;
        transform: scale(0.8);
    }

</style>
